import { render, staticRenderFns } from "./edittagmodel.vue?vue&type=template&id=41047548&scoped=true"
import script from "./edittagmodel.vue?vue&type=script&lang=js"
export * from "./edittagmodel.vue?vue&type=script&lang=js"
import style0 from "./edittagmodel.vue?vue&type=style&index=0&id=41047548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41047548",
  null
  
)

export default component.exports